import { ProTable, ProTableProps } from "@ant-design/pro-components";
import type { ParamsType } from "@ant-design/pro-provider";
import { ColumnType } from "antd/es/table";
import React from "react";
import { Resizable } from "react-resizable";

const CustomProTable = <
  DataType extends Record<string, any>,
  Params extends ParamsType = ParamsType,
  ValueType = "text"
>(
  props: ProTableProps<DataType, Params, ValueType> & {
    isResizablePresent?: boolean;
    resizableColumnSelect?: [];
    handleResize: (index: number, id?: number) => void;
  }
) => {
  const components = {
    header: {
      cell: ResizableTitle,
    },
  };

  const resizableColumns =
    props.columns &&
    props.columns.map((col: any, index: any) => ({
      ...col,
      children: col.children
        ? col.children.map((child: any, id: any) => ({
            ...child,
            onHeaderCell: (column: ColumnType<DataType>) => ({
              width: column.width,
              onResize: props.handleResize(index, id),
            }),
          }))
        : undefined,
      onHeaderCell: (column: ColumnType<DataType>) => ({
        width: column.width,
        onResize: props.handleResize(index),
      }),
    }));

  return (
    <ProTable<DataType, Params, ValueType>
      {...props}
      components={components}
      // columns={
      //   props.isResizablePresent && props.resizableColumnSelect?.length === props.columns?.length
      //     ? props.resizableColumnSelect?.map((col: any, index: any) => {
      //         if (props.columns) {
      //           const matchItem = props.columns.find((d) => d.key === col.key);
      //           return {
      //             ...col,
      //             ...matchItem,
      //             width: col.width,
      //             onHeaderCell: (column: ColumnType<DataType>) => ({
      //               width: column.width,
      //               onResize: props.handleResize(index),
      //             }),
      //           };
      //         } else {
      //           return {
      //             ...col,
      //             onHeaderCell: (column: ColumnType<DataType>) => ({
      //               width: column.width,
      //               onResize: props.handleResize(index),
      //             }),
      //           };
      //         }
      //       })
      //     : resizableColumns
      // }
      // columns={
      //   props.isResizablePresent
      //     ? props.columns?.map((col: any, index: any) => {
      //         // console.log(props.resizableColumnSelect?.find((i: any, id: any) => i.key === col.key));

      //         if (props.resizableColumnSelect?.find((d: any) => d.key === col.key)) {
      //           if (props.columns) {
      //             const matchItem: any = props.resizableColumnSelect.find((d: any) => d.key === col.key);
      //             // console.log(matchItem);
      //             return {
      //               ...col,
      //               // ...matchItem,
      //               width: matchItem.width,
      //               children: col.children
      //                 ? col.children.map((child: any, id: any) => ({
      //                     ...child,
      //                     onHeaderCell: (column: ColumnType<DataType>) => ({
      //                       width: column.width,
      //                       onResize: props.handleResize(index, id),
      //                     }),
      //                   }))
      //                 : undefined,
      //               onHeaderCell: (column: ColumnType<DataType>) => ({
      //                 width: column.width,
      //                 onResize: props.handleResize(index),
      //               }),
      //             };
      //           } else {
      //             return {
      //               ...col,
      //               children: col.children
      //                 ? col.children.map((child: any, id: any) => ({
      //                     ...child,
      //                     onHeaderCell: (column: ColumnType<DataType>) => ({
      //                       width: column.width,
      //                       onResize: props.handleResize(index, id),
      //                     }),
      //                   }))
      //                 : undefined,
      //               onHeaderCell: (column: ColumnType<DataType>) => ({
      //                 width: column.width,
      //                 onResize: props.handleResize(index),
      //               }),
      //             };
      //           }
      //         } else {
      //           return {
      //             ...col,
      //             onHeaderCell: (column: ColumnType<DataType>) => ({
      //               width: column.width,
      //               onResize: props.handleResize(index),
      //             }),
      //           };
      //         }
      //       })
      //     : resizableColumns
      // }
      columns={
        // Map từng dòng để lấy gán hàm onHeaderCell và width
        props.isResizablePresent
          ? props.columns?.map((col: any, index: any) => {
              // tìm column trong resizableColumnSelect để lấy width nếu có thì lấy width và gán hàm onHeaderCell
              //  không có thì chỉ gán onHeaderCell
              if (
                props.resizableColumnSelect?.find((d: any) => d.key === col.key)
              ) {
                return {
                  ...col,
                  children: col.children
                    ? col.children.map((child: any, id: any) => ({
                        ...child,
                        onHeaderCell: (column: ColumnType<DataType>) => ({
                          width: column.width,
                          onResize: props.handleResize(index, id),
                        }),
                      }))
                    : undefined,
                  onHeaderCell: (column: ColumnType<DataType>) => ({
                    width: column.width,
                    onResize: props.handleResize(index),
                  }),
                };
              } else {
                return {
                  ...col,
                  onHeaderCell: (column: ColumnType<DataType>) => ({
                    width: column.width,
                    onResize: props.handleResize(index),
                  }),
                };
              }
            })
          : props.columns
      }
      className={
        "[&_table>thead>tr>th]:!bg-[#1677FF] [&_.ant-table-column-sorter]:!text-white [&_table>thead>tr>th]:!text-white [&_table>thead>tr>th>.ant-table-column-sorter]:!text-white" +
        " [&_.ant-pro-table-column-setting-list-item-title]:clamp-1 [&_.ant-pro-card-body]:!p-0" +
        " [&_.ant-table-header]:!rounded-none [&_.ant-table-cell-scrollbar]:!rounded-none [&_.ant-table-thead>tr>th]:!rounded-none " +
        "[&_.ant-pro-table-list-toolbar-container]:!pt-0 [&_td]:leading-normal " +
        props.className
      }
      bordered
      size="small"
      cardBordered={false}
      search={false}
      options={
        props.options !== undefined
          ? props.options
          : {
              setting: {
                listsHeight: 200,

                draggable: true,
              },
              density: false,
              fullScreen: true, // Giữ lại tùy chọn toàn màn hình
              reload: true, // Giữ lại tùy chọn làm mới
            }
      }
      scroll={props.scroll ? props.scroll : { y: "500px", x: "100%" }}
    />
  );
};

interface ResizableTitleProps {
  onResize: any;
  width: number;
  [x: string]: any;
}

export const ResizableTitle: React.FC<ResizableTitleProps> = (props) => {
  const { onResize, width, ...restProps } = props;
  if (!width) {
    return <th {...restProps} />;
  }
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          className="react-resizable-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default CustomProTable;
